import * as zod from 'zod';

import { PayloadState } from '../../types';

export default zod.object({
  payload: PayloadState,
});
